<ng-template #loading>
  <app-loading></app-loading>
</ng-template>

<div *ngIf="footers | async as footerOptions; else loading">
  <form [formGroup]="form" (ngSubmit)="submit()" class="form">
    <h4>{{'wizard.whenStart' | translate}}</h4>

    <mat-form-field appearance="fill">
      <mat-label>{{'wizard.dateFrom' | translate}}</mat-label>
      <input matInput [matDatepicker]="picker" formControlName="dateFrom" [min]="minDate" [errorStateMatcher]="errorStateMatcher">
      <mat-hint>YYYY-MM-DD</mat-hint>
      <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
      <mat-error *ngIf="form.hasError('required', ['dateFrom'])">{{'fieldRequired' | translate}}</mat-error>
      <mat-error *ngIf="form.hasError('dateInvalid', ['dateFrom'])">{{'futureDateInvalid' | translate}}</mat-error>
      <mat-error *ngIf="form.hasError('lowerThanInvalid', ['dateFrom'])">{{'dateRangeInvalid' | translate}}</mat-error>
    </mat-form-field>

    <app-searchable-select
      formControlName="tmplFrom"
      appearance="fill"
      [label]="'wizard.template' | translate"
      [options]="footerOptions"
      [displayWith]="footerLabel"
      [valueWith]="footerValue"
      [errorStateMatcher]="errorStateMatcher"
      [required]="true"
    ></app-searchable-select>
    <mat-error *ngIf="form.hasError('required', ['tmplFrom']) && errorStateMatcher.submitAttempted">{{'fieldRequired' | translate}}</mat-error>

    <h4>{{'wizard.whenFinish' | translate}}</h4>

    <mat-form-field appearance="fill">
      <mat-label>{{'wizard.dateTo' | translate}}</mat-label>
      <input matInput [matDatepicker]="picker2" formControlName="dateTo" [min]="minDate" [errorStateMatcher]="errorStateMatcher">
      <mat-hint>YYYY-MM-DD</mat-hint>
      <mat-datepicker-toggle matIconSuffix [for]="picker2"></mat-datepicker-toggle>
      <mat-datepicker #picker2></mat-datepicker>
      <mat-error *ngIf="form.hasError('required', ['dateTo'])">{{'fieldRequired' | translate}}</mat-error>
      <mat-error *ngIf="form.hasError('greaterThanInvalid', ['dateTo'])">{{'dateRangeInvalid' | translate}}</mat-error>
    </mat-form-field>

    <app-searchable-select
      formControlName="tmplTo"
      appearance="fill"
      [label]="'wizard.template' | translate"
      [options]="footerOptions"
      [displayWith]="footerLabel"
      [valueWith]="footerValue"
      [errorStateMatcher]="errorStateMatcher"
      [required]="true"
    ></app-searchable-select>
    <mat-error *ngIf="form.hasError('required', ['tmplTo']) && errorStateMatcher.submitAttempted">{{'fieldRequired' | translate}}</mat-error>

    <div class="actions">
      <button
        mat-raised-button
        [disabled]="updating"
        type="submit"
      >
        <mat-spinner *ngIf="updating" diameter="20" class="dc-btn-spinner"></mat-spinner>
        {{(updating ? 'footers.setting' : 'wizard.schedule') | translate}}
      </button>
    </div>
  </form>
</div>
